var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"GlobalFormDemo"},[_c('GlobalForm',{attrs:{"init-data":_vm.initData,"form-item-list":_vm.formItemList,"inline":true,"labelWidth":90,"round":"","needBtnLoading":true,"confirmBtnName":"查询"},on:{"handleConfirm":_vm.handleConfirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }